/* WINGOMART homepage motion + interaction — lightweight port of the mockup's
   cart.js motion system (design/secretlab-rebuild/cart.js).
   Module 1 (always runs): functional bits — carousels, partner centering,
   ambassador card toggle. Module 2 (skipped under prefers-reduced-motion):
   hero stagger, reveal-on-scroll with sweep() safety net, scroll progress. */

/* ---- Module 1: functional (no motion preference needed) ---- */
(function () {
  'use strict';

  function init() {
    /* simple carousels: product row + partner slides */
    document.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-carousel-prev') || btn.getAttribute('data-carousel-next');
        var track = document.getElementById(id);
        if (!track) return;
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 24 : 360;
        track.scrollBy({ left: btn.hasAttribute('data-carousel-prev') ? -step : step, behavior: 'smooth' });
      });
    });

    /* center the captioned partner slide on load */
    var t = document.getElementById('wmhPartnerTrack');
    if (t && t.children[1]) {
      var s = t.children[1];
      t.scrollLeft = s.offsetLeft - (t.clientWidth - s.getBoundingClientRect().width) / 2;
    }

    /* ambassador cards: click to activate */
    document.querySelectorAll('.wmh-amb-card').forEach(function (card) {
      card.addEventListener('click', function () {
        document.querySelectorAll('.wmh-amb-card').forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- Module 2: motion (reduced-motion safe) ---- */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var css = ''
    + '.wmh-prog{position:fixed;top:0;left:0;height:2.5px;width:100%;transform-origin:0 50%;transform:scaleX(0);'
    + 'background:#F26800;z-index:300;pointer-events:none}'
    + '.wm-rev{opacity:0;transform:translateY(24px);transition:opacity .65s ' + EASE + ',transform .65s ' + EASE + '}'
    + '.wm-rev.wm-in{opacity:1;transform:none}'
    + '.wm-hero-el{opacity:0;transform:translateY(26px);transition:opacity .8s ' + EASE + ',transform .8s ' + EASE + '}'
    + '.wm-hero-el.wm-in{opacity:1;transform:none}'
    + '.wm-kb{transition:transform 7s cubic-bezier(.2,.6,.3,1)}';

  function init() {
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);

    /* scroll progress bar */
    var prog = document.createElement('div');
    prog.className = 'wmh-prog';
    document.body.appendChild(prog);

    /* hero entrance: stagger children + slow settle on the hero image */
    var heroIn = document.querySelector('.wmh-hero-in');
    if (heroIn) {
      Array.prototype.forEach.call(heroIn.children, function (el, i) {
        el.classList.add('wm-hero-el');
        setTimeout(function () { el.classList.add('wm-in'); }, 140 + i * 130);
      });
      var heroBg = document.querySelector('.wmh-hero .wmh-cover');
      if (heroBg) {
        heroBg.style.transform = 'scale(1.06)';
        heroBg.classList.add('wm-kb');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { heroBg.style.transform = 'scale(1)'; });
        });
      }
    }

    /* staggered reveals: groups opt in with [data-wm-reveal]; children stagger.
       Only below-the-fold groups animate (above-fold content must not flash). */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var kids = en.target.__wmKids || [];
        kids.forEach(function (k, i) {
          setTimeout(function () { k.classList.add('wm-in'); }, i * 90);
        });
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    document.querySelectorAll('[data-wm-reveal]').forEach(function (group) {
      if (group.getBoundingClientRect().top < innerHeight * 0.85) return;
      var kids = Array.prototype.filter.call(group.children, function (k) {
        return k.getBoundingClientRect().height > 40;
      });
      if (kids.length < 2 || kids.length > 20) return;
      kids.forEach(function (k) { k.classList.add('wm-rev'); });
      group.__wmKids = kids;
      io.observe(group);
    });

    /* sweep() safety net — force-reveal anything the observer missed
       (fast scrolls, anchor jumps), same pattern as the mockup */
    function sweep() {
      var lim = innerHeight * 0.96;
      document.querySelectorAll('.wm-rev:not(.wm-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < lim) el.classList.add('wm-in');
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var max = document.documentElement.scrollHeight - innerHeight;
        prog.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, scrollY / max) : 0) + ')';
        sweep();
      });
    }
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    setTimeout(sweep, 800);
    addEventListener('load', function () { setTimeout(sweep, 300); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
